import React from 'react'
import { Form } from 'semantic-ui-react'
import { FilterSchema } from '@adc/blueprint'
import classnames from 'classnames/bind'
import CheckboxField from '../../../formFields/checkboxField'
import StandardFieldLabel from '../../../formFields/formFieldWrapper/standardFieldLabel'
import { _colorVars } from '../../../../constants/colorVars'
import styles from './styles.scss'
const cx = classnames.bind(styles)

type BooleanProps = FilterSchema.FilterLayoutProps<
  FilterSchema.FilterBooleanDefinition,
  FilterSchema.BooleanValueType
>

const Boolean: React.FunctionComponent<BooleanProps> = ({
  definition,
  compact,
  value,
  elmId,
  onChange,
}) => {
  const renderDescription = () => {
    if (!definition.description) return ''

    if (Array.isArray(definition.description)) {
      return (
        <>
          <div style={{ flexBasis: '100%', height: 0 }} />
          <span
            style={{
              color: _colorVars.utkColorGrayMedium,
              fontSize: '14px',
            }}
          >
            {definition.description.map((item, index) => {
              if (item.type === 'link' && item.href) {
                return (
                  <a
                    key={index}
                    target='_blank'
                    href={item.href}
                    rel='noopener noreferrer'
                  >
                    {item.label}
                  </a>
                )
              } else {
                return (
                  <React.Fragment key={index}>{item.label} </React.Fragment>
                )
              }
            })}
          </span>
        </>
      )
    }

    return definition.description
  }

  return (
    <Form style={{ marginTop: 6 }}>
      <CheckboxField
        className={cx('no-margin-checkbox')}
        key={definition.name}
        compact={compact}
        label={
          <StandardFieldLabel
            checkboxType='checkbox'
            elmId={`${elmId}_${definition.name}_label`}
            label={definition.label as string}
            subLabel={renderDescription() as string}
          />
        }
        elmId={`${elmId}_${definition.name}`}
        name={definition.name}
        value={definition.name}
        role='info'
        // tooltip={definition.tooltip} // TODO handle tooltips
        checked={value}
        onChange={(
          _e: React.ChangeEvent<HTMLInputElement>,
          data: Record<string, unknown>
        ) => {
          onChange(definition.name, data.checked as boolean)
        }}
      />
    </Form>
  )
}

export default Boolean
